import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import React from 'react'

export function useBodyScrollLock(ref: React.RefObject<HTMLElement | Element | null>) {
  const lock = React.useCallback(
    () => ref.current && disableBodyScroll(ref.current, { allowTouchMove: () => true }),
    [ref.current]
  )
  const unlock = React.useCallback(() => ref.current && enableBodyScroll(ref.current), [ref.current])

  React.useEffect(() => {
    return function cleanup() {
      return clearAllBodyScrollLocks()
    }
  }, [])

  return { lock, unlock }
}
